import React, {Fragment, useState} from 'react';
import {Label} from '@/components/atoms/texts/label';
import ListOfActions from '@/components/organisms/navigation/ListOfActions';
import SortButton from '@/components/molecules/buttons/Sort';
import Notification from '@/components/organisms/notification/Notification';
import {Toaster} from '@/components/organisms/feedback/toaster';
import LineArt from '@/assets/images/lineArt.png';
import {Button} from '@/components/molecules/buttons/button';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import {useNotifications} from '@/hooks/global-hooks/NotificationContext';

export default function ConsultantIndex() {
    const {
        actions,
        informations,
        error,
        sortNotifications,
        loading,
        readNotification,
        markAllAsRead,
        refetch
    } = useNotifications();

    const [sortByDateAscInformations, setSortByDateAscInformations] = useState(true);
    const [sortByDateAscActions, setSortByDateAscActions] = useState(true);

    const handleSortNotifications = (type) => {
        if (type == 'informations') {
            sortNotifications(sortByDateAscInformations ? 'asc' : 'desc', type);
            setSortByDateAscInformations(!sortByDateAscInformations);
        } else {
            sortNotifications(sortByDateAscActions ? 'asc' : 'desc', type);
            setSortByDateAscActions(!sortByDateAscActions);
        }
    };

    return (
        <div className="flex h-full w-full relative  overflow-hidden">


            <div
                // defaultSize={15}
                className=" min-w-[200px] lg:min-w-[260px] p-secondDegree h-full z-20"
                // id="actions-panel"
                // order={2}
            >
                <div className="flex flex-col text-center gap-secondDegree w-full h-full">
                    <div><Label
                        size="h3"
                        fontWeight="bold"
                        className="flex "
                        message="consultants.dashboard.title.grpActions"
                    /></div>
                    <ListOfActions className="h-full overflow-scroll no-scrollbar w-full flex flex-col gap-4 "/>
                </div>
            </div>

            <div
                // defaultSize={85}
                className="h-full z-10  overflow-auto flex flex-col"
                id="notifications-panel"
                // order={3}
            >
                <img src={LineArt} onDragStart={(e) => e.preventDefault()} className="bgLineArt overflow-hidden"/>
                <div className="flex flex-col xl:grid xl:grid-cols-2 divide-x h-full">


                    <div className="flex flex-col overflow-auto	h-1/2 xl:h-auto">
                        <div className="p-secondDegree flex justify-between gap-2">
                            <div className="flex flex-col	grow">
                                <Label
                                    size="h3"
                                    fontWeight="bold"
                                    className=""

                                    message="consultants.dashboard.title.recent"
                                />
                                <Label
                                    size="body"
                                    className=""
                                    message="consultants.dashboard.title.recentMessage"
                                />
                            </div>
                            <Button onClick={() => markAllAsRead('actions')} style="ghost" sizePadding="pill"
                                    className="w-min rounded-sm" showLeftIcon leftIcon={<DoneAllIcon/>}
                                    showText={false}/>
                            <SortButton
                                type="date"
                                sort={sortByDateAscActions ? 'up' : 'down'}
                                onClick={() => handleSortNotifications('actions')}
                            />
                        </div>
                        <div className="space-y-4 p-4 flex flex-col h-full overflow-auto ">
                            {/* {console.log("actions dans consultant index", actions)} */}
                            {(loading && actions.length === 0) ? <span className="loader"></span> : <>
                                {actions.map((notification, index) => (
                                    <Notification key={notification.uuid} notification={notification}/>
                                ))}</>}
                            {(error && !actions) && <Label
                                size="bodySmall"
                                fontWeight="regular"
                                fontFamily=""
                                className=" "
                                message="error.fetchUnsuccessfull"
                            />}
                        </div>
                    </div>
                    <div className="flex flex-col overflow-auto	h-1/2 xl:h-auto">
                        <div className="p-secondDegree flex justify-between gap-2">
                            <div className="flex flex-col	grow">
                                <Label
                                    size="h3"
                                    fontWeight="bold"
                                    className=""
                                    message="consultants.dashboard.title.notifications"
                                />
                                <Label
                                    size="body"
                                    className=""
                                    message="consultants.dashboard.title.notificationsMessage"
                                />
                            </div>
                            <Button onClick={() => markAllAsRead('informations')} style="ghost" sizePadding="pill"
                                    className="w-min rounded-sm" showLeftIcon leftIcon={<DoneAllIcon/>}
                                    showText={false}/>

                            <SortButton
                                type="date"
                                sort={sortByDateAscInformations ? 'up' : 'down'}
                                onClick={() => handleSortNotifications('informations')}
                            />
                        </div>
                        <div className="space-y-4 p-4 flex flex-col h-full overflow-auto">
                            {(loading && informations.length === 0) ? <span className="loader"></span> : informations.map((notification, index) => (
                                <Notification key={notification.uuid} notification={notification}
                                              readNotification={readNotification}/>
                            ))}
                            {(error && !informations) && <Label
                                size="bodySmall"
                                fontWeight="regular"
                                fontFamily=""
                                className=" "
                                message="error.fetchUnsuccessfull"
                            />}

                            {}
                        </div>
                    </div>
                </div>
            </div>
            <Toaster/>
        </div>
    );
}
